import Repository, {baseUrl} from './Repository';

export async function startConversation(token, inquiryId) {
    const endPoint = `/product/conversation`;

    try {
        const response = await Repository.post(`${baseUrl}${endPoint}`, null, {
            headers: {
                token: token,
            },
            params: {
                inquiryId: inquiryId,
            },
        });
        return response.data ? response.data : {code: 1000, message: response.statusText};
    } catch (error) {
        console.error(JSON.stringify(error));
        return {code: 1001, message: error.message};
    }
}

export async function getConversation(token, id) {
    const endPoint = `/product/conversation/${id}`;

    try {
        const response = await Repository.get(`${baseUrl}${endPoint}`, {
            headers: {
                token: token,
            },
        });
        return response.data ? response.data : {code: 1000, message: response.statusText};
    } catch (error) {
        console.error(JSON.stringify(error));
        return {code: 1001, message: error.message};
    }
}

export async function closeConversation(token, id, result, reason) {
    const endPoint = `/product/conversation/${id}/close`;

    try {
        const response = await Repository.post(`${baseUrl}${endPoint}`, null, {
            headers: {
                token: token,
            },
            params: {
                result: result,
                reason: reason,
            },
        });
        return response.data ? response.data : {code: 1000, message: response.statusText};
    } catch (error) {
        console.error(JSON.stringify(error));
        return {code: 1001, message: error.message};
    }
}


export async function sendMessage(token, conversationId, messageType, message, messageData) {
    const endPoint = `/product/conversation/${conversationId}/message`;
    const formData = new FormData()
    formData.append('type', messageType);
    formData.append('text', message);
    formData.append('messageData', messageData);

    try {
        const response = await Repository.postForm(`${baseUrl}${endPoint}`, formData, {
            headers: {
                token: token,
            },
        });
        return response.data ? response.data : {code: 1000, message: response.statusText};
    } catch (error) {
        console.error(JSON.stringify(error));
        return {code: 1001, message: error.message};
    }
}

export async function myConversations(token) {
    const endPoint = `/product/conversations/my`;

    try {
        const response = await Repository.get(`${baseUrl}${endPoint}`, {
            headers: {
                token: token,
            },
        });
        return response.data ? response.data : {code: 1000, message: response.statusText};
    } catch (error) {
        console.error(JSON.stringify(error));
        return {code: 1001, message: error.message};
    }
}
